<div class="py-8 px-50 flex flex-col justify-center">
  <ng-container>
    <mat-card>
      <mat-card-content>
        <mat-card>
          <mat-card-content>
            <div class="flex justify-center">
              <!-- <img src="assets/cnamLogo.png" alt="" class="w-2/6" /> -->
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card>         
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="center center">
                <br>
                <!-- <div fxLayout="row" fxLayoutAlign="start none"> -->
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="25">
                    <mat-label>Identité complète</mat-label>
                    <mat-icon matSuffix [hidden]="id">sentiment_very_dissatisfied</mat-icon>
                    <mat-icon matSuffix [hidden]="!id">sentiment_very_satisfied</mat-icon>
                    <input matInput type="text" [(ngModel)]="id">
                  </mat-form-field>
                  <div fxFlex="5"></div>
                  <button class="bg-blue-600 text-white rounded-md p-3 flex items-center mx-4" (click)="search()">
                    <mat-icon class="mr-2">search</mat-icon>Recherche
                  </button>
                <!-- </div> -->
              </div>
            </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
